export default `
<ol class="progress_bar col-md-4 col-sm-4 col-xs-12 text-right" aria-label="Progress step" role="list">
  <li class="circle" ng-repeat-start="step in $ctrl.steps" aria-label="Step {{step}}, {{$ctrl.stepClass(step)}}" ng-class="$ctrl.stepClass(step)">
    <span class="label" aria-hidden="true">{{step}}</span>
  </li>
  <span ng-repeat-end class="bar" ng-hide="$last" aria-hidden="true"></span>
</ol>
`;
